import { render, staticRenderFns } from "./PartnerConfig.vue?vue&type=template&id=27755d22&scoped=true&"
import script from "./PartnerConfig.vue?vue&type=script&lang=js&"
export * from "./PartnerConfig.vue?vue&type=script&lang=js&"
import style0 from "./PartnerConfig.vue?vue&type=style&index=0&id=27755d22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27755d22",
  null
  
)

export default component.exports